import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class EndpointLocationProviderService {

    public getWindowURL(): string {
        return `${window.location.protocol}//${window.location.hostname}/`;
    }

    public isLocalHost(): boolean {
        return window.location.hostname.includes('localhost');
    }

    public getEndpointURI(endpoint: any): string {

        if (environment.production) {
            return `${this.getWindowURL() + endpoint.link}`;
        }

        if (environment.ENDPOINTS_DEBUG && environment.ENDPOINTS_DEBUG.includes(`${endpoint.link}`)) {
            return endpoint.localhost;
        }

        if(this.isLocalHost()){
            return `https://d-acsafeweb.safewebpss.com.br/${endpoint.link}`; 
        }

        return `${window.location.protocol}//${window.location.hostname}/${endpoint.link}`;
    }
}
